const currencyMap = {
    'th': 'THB',
    'tw': 'TWD',
    'ko': 'KRW',
}

const lang = process.env.VUE_APP_LANG?process.env.VUE_APP_LANG:'tw'
let panypayBase = process.env.VUE_APP_PANPAY_URL
if (!panypayBase) {
    if (process.env.VUE_APP_HOST == window.location.host)
        panypayBase = 'https://pay-tw.panggame.com/'
    else
        panypayBase = 'https://test-pay-tw.panggame.com/'
}
const isMobile = !!window.navigator.userAgent.match(/AppleWebKit.*Mobile.*/)


const callbacks = {
    submit: (data) => {
        console.log(data)
    },
    approve: (data) => {
        console.log(data)
    },
}

function createPangPayIframe (data) {
    let payBaseUrl = panypayBase + lang + '/home?currency=' + currencyMap[lang]
    if (data) {
        payBaseUrl = (
            payBaseUrl  + '&user_id=' + data.user_id + '&client_id=' + data.client_id
            + '&timestamp=' + data.timestamp + '&sign=' + data.sign
            + '&nounce=' + data.nounce)
        if (data.payment_methods && Array.isArray(data.payment_methods)) {
            for (let i in data.payment_methods) {
                payBaseUrl += '&payment_methods=' + data.payment_methods[i]
            }
        }
    }
    let iframe = document.getElementById('pangpay-iframe');
    if (iframe) {
        if (iframe.getAttribute('src') != payBaseUrl) {
            iframe.setAttribute('src', payBaseUrl)
        }
    }
    else {
        iframe = document.createElement('iframe');
        iframe.setAttribute('src', payBaseUrl)
        iframe.setAttribute('id', 'pangpay-iframe')
        let div = document.getElementById('pangpay-iframe-container')
        if (!div) {
            let body = document.getElementsByTagName('body')[0]
            div = document.createElement('div');
            div.setAttribute('id', 'pangpay-iframe-container')
            body.appendChild(div)
        }
        iframe.onload = function () {
            if (!iframe.getAttribute('style') || iframe.getAttribute('style') =='' || iframe.getAttribute('style') == 'display: block;')
                iframe.setAttribute('style', 'position: fixed; width: 100vw; height: 100vh; z-index: 999999999; top: 0;left: 0;display:none;')
            window.postMessage({
                source: 'pangpay',
                message: 'pangpayReady',
            }, '*');
        }
        iframe.onclick = function (e) {
            e.stopPropagation()
        }
        div.appendChild(iframe)
        window.addEventListener('message', function (e) {
            if (e.data.source == 'pangpay') {
                switch (e.data.message) {
                    case 'cancel':
                        iframe.style.display = 'none';
                        break;
                    case 'submit':
                        callbacks.submit(e.data.data);
                        break;
                    case 'approve':
                        callbacks.approve(e.data.data);
                        iframe.style.display = 'none';
                        break;
                    case 'show':
                        iframe.style.display = 'block';
                        break;
                    case 'next':
                        if (!isMobile) {
                            window.open(e.data.data.url, '_blank')
                            iframe.style.display = 'none';
                        }
                        else
                            window.location = e.data.data.url
                        break;
                    case 'resize':
                        div.setAttribute('style', 'position: fixed; width: 100vw; height: 100vh; z-index: 999999999; top: 0;left: 0;display: flex; background-color: rgba(0,0,0,.68);')
                        div.onclick = function () {
                            window.location.reload(true)
                        }
                        iframe.setAttribute('style', 'width: 700px; height: 500px; display: block; margin: auto;')
                        break;
                    default:
                        console.log(e.data);
                }
            }
        })
    }
}

function createPangPay (data, submit, approve) {
    if (submit)
        callbacks.submit = submit;
    if (approve)
        callbacks.approve = approve;
    let iframe = document.getElementById('pangpay-iframe');
    iframe.contentWindow.postMessage({
        data: data,
        source: 'pangpayHost',
        message: 'updateParams',
    }, '*');
}

function submitRecord (data) {
    let iframe = document.getElementById('pangpay-iframe');
    iframe.contentWindow.postMessage({
        data: data,
        source: 'pangpayHost',
        message: 'submitRecord',
    }, '*');
}

export default {
    createPangPayIframe: createPangPayIframe,
    createPangPay: createPangPay,
    submitRecord: submitRecord,
}